import React from 'react';

interface DoubleQuotesStartProps {
  width?: number;
  height?: number;
}

const DoubleQuotesStart = ({ width, height }: DoubleQuotesStartProps) => {
  return (
    <>
      <svg
        width={width || '18'}
        height={height || '15'}
        viewBox="0 0 18 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 14C0 14.5523 0.447715 15 1 15H6.48421C7.0365 15 7.48421 14.5523 7.48421 14V8.88991C7.48421 8.33762 7.0365 7.88991 6.48421 7.88991H5.07368C4.5214 7.88991 4.06074 7.43732 4.16886 6.89573C4.47772 5.34864 5.52713 4.2044 7.154 3.77885C7.6542 3.64801 8.05263 3.22808 8.05263 2.71105V1.08315C8.05263 0.499442 7.55208 0.0348305 6.97785 0.139542C2.49017 0.957861 0 4.52606 0 9.08257V14ZM9.94737 14C9.94737 14.5523 10.3951 15 10.9474 15H16.4316C16.9839 15 17.4316 14.5523 17.4316 14V8.88991C17.4316 8.33762 16.9839 7.88991 16.4316 7.88991H15.0211C14.4688 7.88991 14.0081 7.43732 14.1162 6.89573C14.4251 5.34864 15.4745 4.2044 17.1014 3.77885C17.6016 3.64801 18 3.22808 18 2.71105V1.08315C18 0.499442 17.4995 0.0348305 16.9252 0.139542C12.4375 0.957861 9.94737 4.52606 9.94737 9.08257V14Z"
          fill="#EFEFEF"
        />
      </svg>
    </>
  );
};

export default DoubleQuotesStart;
